"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../..");
var useGetJSON_1 = __importDefault(require("../../../../hooks/useGetJSON"));
var ConfigProvider_1 = require("../../../../providers/ConfigProvider");
var NestedIcon_1 = __importDefault(require("../../../Icon/NestedIcon"));
var Field_1 = __importDefault(require("../../components/Field"));
var Label_1 = __importDefault(require("../../components/Label"));
var KrajDropdown_1 = __importDefault(require("./KrajDropdown"));
var ObecDropdown_1 = __importDefault(require("./ObecDropdown"));
var OkresDropdown_1 = __importDefault(require("./OkresDropdown"));
var ChildLabel = styled_components_1.default(Label_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 500;\n"], ["\n  font-weight: 500;\n"])));
var FieldWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 1em;\n\n  & > ", " {\n    display: flex;\n    align-items: center;\n    height: 50px;\n    margin-bottom: 1em;\n  }\n"], ["\n  margin-top: 1em;\n\n  & > ", " {\n    display: flex;\n    align-items: center;\n    height: 50px;\n    margin-bottom: 1em;\n  }\n"])), Label_1.default);
var mapDefaultObec = function (obecValues) {
    return {
        selected: obecValues.id,
        option: { value: obecValues.id, label: obecValues.popis },
    };
};
var VyhledavaniSpecializaceField = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var name = _a.name, defaultSelect = _a.defaultSelect, enableReset = _a.enableReset;
    var _h = formik_1.useField(name), field = _h[0], helpers = _h[2];
    var _j = react_1.useState(undefined), kraj = _j[0], setKraj = _j[1];
    var _k = react_1.useState(undefined), okres = _k[0], setOkres = _k[1];
    var _l = react_1.useState(undefined), obec = _l[0], setObec = _l[1];
    var _m = react_1.useState(undefined), uniqueObce = _m[0], setUniqueObce = _m[1];
    var _o = react_1.useState(), defaultOption = _o[0], setDefaultOption = _o[1];
    var ciselnikyUrl = ConfigProvider_1.useConfig().ciselnikyUrl;
    var getObecJSON = useGetJSON_1.default(ciselnikyUrl + "/SoudniObec");
    var value = field.value || {};
    var setDefaultObec = function (obecVal) { return __awaiter(void 0, void 0, void 0, function () {
        var response, defaultObec;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getObecJSON({ id: obecVal.id, kod: obecVal.kod })];
                case 1:
                    response = _a.sent();
                    if (__1.isRight(response)) {
                        if (response.value && response.value.length === 1) {
                            defaultObec = mapDefaultObec(response.value[0]);
                            if (defaultObec)
                                setDefaultOption(defaultObec);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    react_1.useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (defaultSelect) {
            if (((_b = (_a = defaultSelect.values) === null || _a === void 0 ? void 0 : _a.obec) === null || _b === void 0 ? void 0 : _b.id) || ((_d = (_c = defaultSelect.values) === null || _c === void 0 ? void 0 : _c.obec) === null || _d === void 0 ? void 0 : _d.kod)) {
                setDefaultObec((_e = defaultSelect.values) === null || _e === void 0 ? void 0 : _e.obec);
            }
            setObec((_g = (_f = defaultSelect.values) === null || _f === void 0 ? void 0 : _f.obec) === null || _g === void 0 ? void 0 : _g.id);
            setOkres((_h = defaultSelect.values) === null || _h === void 0 ? void 0 : _h.okres);
            setKraj((_j = defaultSelect.values) === null || _j === void 0 ? void 0 : _j.kraj);
            helpers.setValue(defaultSelect.values || {});
        }
    }, [(_c = (_b = defaultSelect === null || defaultSelect === void 0 ? void 0 : defaultSelect.values) === null || _b === void 0 ? void 0 : _b.obec) === null || _c === void 0 ? void 0 : _c.id, (_e = (_d = defaultSelect === null || defaultSelect === void 0 ? void 0 : defaultSelect.values) === null || _d === void 0 ? void 0 : _d.obec) === null || _e === void 0 ? void 0 : _e.kod, (_f = defaultSelect === null || defaultSelect === void 0 ? void 0 : defaultSelect.values) === null || _f === void 0 ? void 0 : _f.okres, (_g = defaultSelect === null || defaultSelect === void 0 ? void 0 : defaultSelect.values) === null || _g === void 0 ? void 0 : _g.kraj]);
    var handleSetKraj = function (selected) {
        setObec(undefined);
        setOkres(undefined);
        setKraj(selected);
        helpers.setValue({ kraj: selected });
        setDefaultOption(undefined);
    };
    var handleSetOkres = function (selected) {
        setOkres(selected);
        setObec(undefined);
        helpers.setValue(__assign(__assign({}, value), { okres: selected, obec: undefined }));
        setDefaultOption(undefined);
    };
    var handleSetObec = function (selected) {
        var selectedObec = uniqueObce === null || uniqueObce === void 0 ? void 0 : uniqueObce.find(function (o) { return o.id === selected; });
        setObec(selected);
        helpers.setValue(__assign(__assign({}, value), { obec: selectedObec }));
    };
    var handleGetObce = function (uniqueObceData) {
        setUniqueObce(uniqueObceData);
    };
    return (react_1.default.createElement("fieldset", { name: name },
        react_1.default.createElement(FieldWrapper, null,
            react_1.default.createElement(Label_1.default, { htmlFor: name }, "S\u00EDdlo / Kontaktn\u00ED adresa"),
            react_1.default.createElement(Field_1.default, null,
                react_1.default.createElement(ChildLabel, { htmlFor: "Kraj" },
                    react_1.default.createElement(NestedIcon_1.default, null),
                    " Soudn\u00ED kraj"),
                react_1.default.createElement(KrajDropdown_1.default, { value: kraj, onChange: handleSetKraj, enableReset: enableReset, inputId: "Kraj" })),
            react_1.default.createElement(Field_1.default, null,
                react_1.default.createElement(ChildLabel, { htmlFor: "Okres" },
                    react_1.default.createElement(NestedIcon_1.default, null),
                    " Okres"),
                react_1.default.createElement(OkresDropdown_1.default, { value: okres, soudniKraj: kraj, onChange: handleSetOkres, enableReset: enableReset, inputId: "Okres" })),
            react_1.default.createElement(Field_1.default, null,
                react_1.default.createElement(ChildLabel, { htmlFor: "Obec" },
                    react_1.default.createElement(NestedIcon_1.default, null),
                    " Obec"),
                react_1.default.createElement(ObecDropdown_1.default, { value: obec, soudniOkres: okres, soudniKraj: kraj, onChange: handleSetObec, defaultOption: defaultOption, enableReset: enableReset, handleGetObce: handleGetObce, inputId: "Obec" })))));
};
VyhledavaniSpecializaceField.defaultProps = {
    enableReset: false,
    defaultSelect: undefined,
};
exports.default = VyhledavaniSpecializaceField;
var templateObject_1, templateObject_2;
